import ExpiredContractPage from "./pages/ExpiredContractPage.vue";
import ExpiredPlanClientPage from "@/app/settings/pages/ExpiredPlanClientPage.vue";
import ExpiredTokenPlanPage from "@/app/settings/pages/ExpiredTokenPlanPage.vue";
import ExpiredTokenPage from "@/app/settings/pages/ExpiredTokenPage.vue";
import ExpiredBillingPage from "@/app/settings/pages/ExpiredBillingPage.vue";
import BillingPage from "@/app/settings/pages/BillingPage.vue";

export default [
  {
    path: "/billing",
    name: "billing",
    component: BillingPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/billing/expired",
    name: "expired",
    component: ExpiredBillingPage,
    meta: { requiresAuth: false, layout: "footer" },
  },
  {
    path: "/token-register/expired",
    name: "register-expired",
    component: ExpiredTokenPage,
    meta: { requiresAuth: false, layout: "footer" },
  },
  {
    path: "/token-plan/expired",
    name: "token-expired",
    component: ExpiredTokenPlanPage,
    meta: { requiresAuth: false, layout: "footer" },
  },
  {
    path: "/plan-client/expired",
    name: "plan-expired",
    component: ExpiredPlanClientPage,
    meta: { requiresAuth: false, layout: "footer" },
  },
  {
    path: "/contract/expired",
    name: "contract-expired",
    component: ExpiredContractPage,
    meta: { requiresAuth: false, layout: "footer" },
  },
];
